import Carousel from './components/Carousel';
import Cookies from './components/Cookies';
import Jarallax from './components/Jarallax';
import SearchBlogPosts from './components/SearchBlogPosts';
import SearchFaqQuestions from './components/SearchFaqQuestions';
import ZohoForm from './components/ZohoForm';
import ServicesPro from './components/services-pro';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Carousel,
      Cookies,
      Jarallax,
      SearchBlogPosts,
      SearchFaqQuestions,
      ZohoForm,
      ServicesPro,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
